import { NavLink, Outlet, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, CalendarCheck, Users, PartyPopper, LogOut, BookOpen, Settings, Newspaper, CalendarDays } from "lucide-react";

const NAV = [
    { to: "/crm", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "crm-nav-dashboard" },
    { to: "/crm/calendario", label: "Calendario", icon: CalendarDays, testid: "crm-nav-calendario" },
    { to: "/crm/reservas", label: "Reservas", icon: CalendarCheck, testid: "crm-sidebar-reservas" },
    { to: "/crm/clientes", label: "Clientes", icon: Users, testid: "crm-nav-clientes" },
    { to: "/crm/eventos", label: "Eventos", icon: PartyPopper, testid: "crm-nav-eventos" },
    { to: "/crm/carta", label: "Carta", icon: BookOpen, testid: "crm-nav-carta" },
    { to: "/crm/blog", label: "Blog", icon: Newspaper, testid: "crm-nav-blog" },
    { to: "/crm/contenido", label: "Contenido", icon: Settings, testid: "crm-nav-contenido" },
];

export default function CrmLayout() {
    const { user, ready, logout } = useAuth();
    const navigate = useNavigate();

    if (!ready) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-carbon">
                <span className="font-body text-piedra text-sm">Cargando...</span>
            </div>
        );
    }
    if (!user) return <Navigate to="/crm/login" replace />;

    const onLogout = async () => {
        await logout();
        navigate("/crm/login");
    };

    return (
        <div className="min-h-screen bg-carbon flex">
            <aside className="hidden md:flex flex-col w-64 border-r border-dorado/20 bg-carbon-suave/40">
                <div className="p-8 border-b border-dorado/20">
                    <span className="font-heading text-2xl tracking-[0.25em] text-dorado">
                        TENERÍA
                    </span>
                    <p className="font-body uppercase tracking-[0.3em] text-[0.6rem] text-piedra mt-2">
                        CRM · {user.nombre}
                    </p>
                </div>
                <nav className="flex-1 p-4 space-y-1">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            data-testid={n.testid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 font-body text-sm transition-colors border-l-2 ${
                                    isActive
                                        ? "border-dorado text-dorado bg-carbon"
                                        : "border-transparent text-crema hover:text-dorado"
                                }`
                            }
                        >
                            <n.icon size={16} />
                            <span className="tracking-wider">{n.label}</span>
                        </NavLink>
                    ))}
                </nav>
                <button
                    onClick={onLogout}
                    data-testid="crm-logout"
                    className="m-4 px-4 py-3 border border-dorado/30 text-crema hover:border-dorado hover:text-dorado transition-colors flex items-center gap-2 font-body text-xs uppercase tracking-[0.2em]"
                >
                    <LogOut size={14} /> Salir
                </button>
            </aside>

            <main className="flex-1 overflow-x-hidden">
                {/* Mobile top */}
                <header className="md:hidden flex items-center justify-between p-4 border-b border-dorado/20 bg-carbon-suave/40">
                    <span className="font-heading text-xl tracking-[0.2em] text-dorado">
                        TENERÍA
                    </span>
                    <button
                        onClick={onLogout}
                        className="text-piedra hover:text-dorado"
                        aria-label="Salir"
                    >
                        <LogOut size={18} />
                    </button>
                </header>
                <nav className="md:hidden flex border-b border-dorado/20 overflow-x-auto">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            className={({ isActive }) =>
                                `flex-1 min-w-[100px] text-center px-4 py-3 font-body text-xs uppercase tracking-[0.2em] ${
                                    isActive ? "text-dorado border-b border-dorado" : "text-piedra"
                                }`
                            }
                        >
                            {n.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="p-6 md:p-10 max-w-[1400px] mx-auto">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
